import RedirectToProductUpdatesPage from 'modules/discover/pages/RedirectToProductUpdates'

const DiscoverGuardPage = () => {
  return <RedirectToProductUpdatesPage />
}

export default DiscoverGuardPage
